import React from "react";
import "./Footer.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import logo from "../../Assets/round.png";
import {
  faTwitter,
  faDiscord,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";
function Footer({ prop }) {
  return (
    <div className="footer">
      {/* <div className="footer_left">
        <h1>Get on the List</h1>
        <input type="email" placeholder="Enter email address" />
      </div> */}

      <div className="footer_middle">
        <img src={logo} alt="" />
        <div className="small-box-div">
        <a href="https://twitter.com/mystical_pets" target="_blank"><FontAwesomeIcon icon={faTwitter} /></a>
          <a href="https://discord.gg/wT78pzNJJh" target="_blank"><FontAwesomeIcon icon={faDiscord} /></a>
          <a href="https://www.instagram.com/mysticalpets_nft/?hl=en" target="_blank"><FontAwesomeIcon icon={faInstagram} /></a>
        </div>
        <p>Mystical Pets © 2021 All rights reserved.</p>
      </div>
    </div>
  );
}

export default Footer;
